const getFormConfig = () => {
  return {
    programFinderTextField: [
      {
        name: 'query',
        type: 'text',
        placeholder: 'Algolia.SearchPage.TextField.Placeholder',
        searchButton: true,
        wrapperClasses: 'program-finder-textfield flex-grow'
      },
    ],
    programFinderSidebarFilters: [
      {
        name: 'field_prgm_type',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.ProgramType.Label',
        accordionWrapper: true,
        options: []
      },
      {
        name: 'field_prgm_delivery_type',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.DeliveryMethod.Label',
        accordionWrapper: true
      },
      {
        name: 'field_prgm_housing_opt',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.HousingType.Label',
        accordionWrapper: true
      },
      {
        name: 'field_prgm_academic_level',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.AcademicLevel.Label',
        accordionWrapper: true
      },
      {
        name: 'field_prgm_university_nid',
        type: 'select',
        label: 'Algolia.SearchPage.UniversityName.Label',
        placeholder: 'Algolia.SearchPage.Select.Placeholder',
        accordionWrapper: true,
        isMulti: true
      },
      {
        name: 'field_prgm_rank_group',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.UniversityRanking.Label',
        accordionWrapper: true
      },
      {
        name: 'field_prgm_disciplines_tid',
        type: 'select',
        label: 'Algolia.SearchPage.AcademicDiscipline.Label',
        placeholder: 'Algolia.SearchPage.Select.Placeholder',
        accordionWrapper: true,
        isMulti: true,
      },
      {
        name: 'hasCredits',
        type: 'toggle',
        label: 'Algolia.SearchPage.CreditPrograms.Label',
        labelFirst: true,
        trueValue: 'field_prgm_credits_available:true',
        falseValue: ''
      },
      {
        name: 'regions',
        type: 'radios',
        label: 'Algolia.SearchPage.Regions.Label',
        accordionWrapper: true
      },
      {
        name: 'destinations',
        type: 'select',
        label: 'Algolia.SearchPage.SubregionsCities.Label',
        placeholder: 'Algolia.SearchPage.Select.Placeholder',
        accordionWrapper: true,
        callback: 'createDestinationHierarchy'
      },
      {
        name: 'field_prgm_lang_instruct',
        type: 'select',
        label: 'Algolia.SearchPage.LanguageOfInstruction.Label',
        placeholder: 'Algolia.SearchPage.Select.Placeholder',
        accordionWrapper: true
      },
      {
        name: 'field_prgm_lang_pre_lvl',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.languagePrerequisiteLevel.Label',
        accordionWrapper: true
      },
      {
        name: 'gpa_range',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.GPARequirements.Label',
        accordionWrapper: true,
        options: [
          {
            label: 'Algolia.SearchPage.GPARequirements.Options.None',
            value: 'prgm_gpa_req < 0'
          },
          {
            label: '0.0-2.0',
            value: 'prgm_gpa_req:0 TO 2'
          },
          {
            label: '2.1-3.0',
            value: 'prgm_gpa_req:2.01 TO 3'
          },
          {
            label: '3.1+',
            value: 'prgm_gpa_req > 3.01'
          },
        ]
      },
      {
        name: 'field_prgm_term_type',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.TermType.Label',
        accordionWrapper: true
      },
      {
        name: 'price_range',
        type: 'checkboxes',
        label: 'Algolia.SearchPage.ProgramFees.Label',
        accordionWrapper: true,
        options: [
          {
            label: '$',
            value: 'field_prgm_cost_est:0 TO 10000'
          },
          {
            label: '$$',
            value: 'field_prgm_cost_est:10001 TO 20000'
          },
          {
            label: '$$$',
            value: 'field_prgm_cost_est:20001 TO 30000'
          },
          {
            label: '$$$$',
            value: 'field_prgm_cost_est > 30000'
          },
        ]
      },
    ],
    programFinderSorting: [
      {
        name: 'sortBy',
        type: 'sortSelect',
        label: 'Algolia.SearchPage.SortBy.Label',
        options: [
          {
            label: 'Algolia.SearchPage.SortBy.Relevancy.option',
            value: window.drupalSettings.algoliaSearch?.programFinder?.default || '',
          },
          {
            label: 'Algolia.SearchPage.SortBy.Newest.option',
            value: window.drupalSettings.algoliaSearch?.programFinder?.sortByReplica || '',
          }
        ]
      }
    ],
    globalSearchTextField: [
      {
        name: 'query',
        type: 'text',
        placeholder: 'Algolia.GlobalSearch.TextField.Placeholder',
        searchButton: true,
        wrapperClasses: 'program-finder-textfield flex-grow'
      },
    ],
    globalSearchSidebar: [
      {
        name: 'type_label',
        type: 'checkboxes',
        label: 'Algolia.GlobalSearch.EventType.Label',
        accordionWrapper: true
      },
    ],
    globalSearchItemsPerPage: [
      {
        name: 'itemsPerPage',
        type: 'sortSelect',
        label: 'Algolia.GlobalSearch.ItemsPerPage.Label',
        options: [
          {
            label: '10',
            value: 10,
          },
          {
            label: '15',
            value: 15,
          },
          {
            label: '20',
            value: 20,
          },
        ],
      },
    ]
  };
};

export default getFormConfig;
